import Api from '../Api';
import StorageToken from '../StorageToken';
export const groups = async auth => {
  const info = userInfo(auth);
  return info.groups;
};
export const getFromUserInfo = async (auth, field) => {
  const info = userInfo(auth);
  return info[field];
};
export const userInfo = async auth => {
  let groupNames = [];
  let moduleNames = [];
  let englishLanguageUuid = '';
  let language = '';
  let timezone = '';
  let storedGroups = JSON.parse(localStorage.getItem(StorageToken.get()));
  if (storedGroups !== null) {
    // check if expired
    if (Date.now() > storedGroups.expires) {
      storedGroups = null;
    } else {
      groupNames = storedGroups.groups;
      moduleNames = storedGroups.modules;
      englishLanguageUuid = storedGroups.englishLanguageUuid;
      language = storedGroups.language;
      timezone = storedGroups.timezone;
    }
  }
  if (storedGroups === null) {
    // get groups from otto_eu
    await Api.getUserGroups(auth).then(response => {
      if (response.data !== undefined && response.data.attributes !== undefined) {
        groupNames = response.data.attributes.group_names;
        moduleNames = response.data.attributes.module_names;
        englishLanguageUuid = response.data.attributes.english;
        language = response.data.attributes.language;
        timezone = response.data.attributes.timezone;
        localStorage.setItem(StorageToken.get(), JSON.stringify({
          groups: groupNames,
          modules: moduleNames,
          englishLanguageUuid,
          language,
          timezone,
          expires: Date.now() + 24 * 60 * 1000 // 1 hour
        }));
      }
    });
  }
  return {
    groups: groupNames,
    modules: moduleNames,
    englishLanguageUuid,
    language,
    timezone
  };
};
export default {
  Default: groups,
  Groups: groups,
  UserInfo: userInfo,
  GetFromUserInfo: getFromUserInfo
};